import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'
import pyClient from '../../Python/PyAPI_Config'

async function getWeaningReport(authState: tsWhoAmI, holding_id: number) {
  return await phpClient(authState)
    .get<any>(`/json/stuart/report/weaningReport.php?holdingID=${holding_id}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getCullReport(authState: tsWhoAmI, holding_id: number) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/report/getAnimalsToCullReport.php?containerID=${holding_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getBPLitterReport(
  authState: tsWhoAmI,
  holding_id: number,
  litter_seq: number,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/report/breedingPairLitters.php?holdingID=${holding_id}&LitterSeq=${litter_seq}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getOldLinesReport(authState: tsWhoAmI, holding_id: number) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/report/linesNotRecentlyUsed.php?holdingID=${holding_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getShippingManifestPDF(authState: any, van_run_date: string) {
  return await pyClient(authState)
    .get<any>(`/reports/shipping/manifest/${van_run_date}/pdf`, {
      responseType: 'arraybuffer',
    })
    .then((response) => response.data)
    .catch((error) => {
      const decode = new Uint8Array(error.response.data)
      const message = String.fromCharCode.apply(
        null,
        decode as unknown as number[],
      )
      return Promise.reject({ ...error.response, data: message })
    })
}

async function getShippingManifestXLSX(authState: any, van_run_date: string) {
  return await pyClient(authState)
    .get<any>(`/reports/shipping/manifest/${van_run_date}/xlsx`, {
      responseType: 'arraybuffer',
    })
    .then((response) => response.data)
    .catch((error) => {
      const decode = new Uint8Array(error.response.data)
      const message = String.fromCharCode.apply(
        null,
        decode as unknown as number[],
      )
      return Promise.reject({ ...error.response, data: message })
    })
}

const ReportService = {
  getWeaningReport,
  getCullReport,
  getBPLitterReport,
  getOldLinesReport,
  getShippingManifestPDF,
  getShippingManifestXLSX,
}

export default ReportService
